import React from "react";

import styled from "@mui/material/styles/styled";

import { ShareIcon } from "@app/common/assets/icons";

import Stack, { StackProps } from "@rui/Stack";

type SharedReportIconProps = StackProps & { size?: "sm" | "md" };

const SharedReportIcon = styled<React.FC<SharedReportIconProps>>(
  ({ size: _s, ...props }) => (
    <Stack variant="center" {...props}>
      <Stack variant="center" className="share-report-icon__middle">
        <Stack variant="center" className="share-report-icon__inner">
          <ShareIcon />
        </Stack>
      </Stack>
    </Stack>
  )
)(({ size = "md", theme }) => ({
  width: "fit-content",
  borderRadius: "50%",
  border: size === "sm" ? "0.5px solid" : "1px solid",
  padding: size === "sm" ? "0.5px" : "1px",
  flexShrink: 0,
  borderColor: theme.palette.shades.primary[150],

  "& .share-report-icon__middle, .share-report-icon__inner": {
    borderRadius: "50%",
    border: size === "sm" ? "0.5px solid" : "1px solid",
    padding: "1px",
    flexShrink: 0,
  },

  "& .share-report-icon__middle": {
    borderColor: theme.palette.shades.primary[200],
  },
  "& .share-report-icon__inner": {
    borderColor: theme.palette.shades.primary[300],
  },

  "& .MuiSvgIcon-root": {
    color: theme.palette.shades.primary[500],
    fontSize: size === "sm" ? "10px" : "14px",
  },
}));

export default SharedReportIcon;
